module.exports = __webpack_public_path__ + "static/assets/bf01dc918ea2dcb213fee7dad6e48245.png";